// extracted by mini-css-extract-plugin
export default {"head":"Banner_head__5Zmf6","textBlock":"Banner_textBlock__Sz3Tc"};